import { GenericService } from '@/services/api/generic.service';
import { Domain } from '@/models';

export class DomainService extends GenericService<Domain> {
  endpoint = 'v1/domains';
}
